import superagent from 'superagent';
import config from 'config';
import userFactory from 'lib/user';

const user = userFactory();
const defaults = {
   	authToken: localStorage.getItem('currentUserJWT'),
    body: null,
    formData: null,
    headers: null,
    method: 'get',
    query: null,
    processResponseInEnvelopeMode: true,
    proxyOrigin: config('customerSiteProxy'),
    url: '',
};

const sendResponse = (req, settings, fn) => {

    req.end((error, response) => {

        if (error && !response) {
            return fn(error);
        }

        let { body, headers, statusCode } = response;

        const { ok } = response;
        headers.status = statusCode;

        if (ok) {
            return fn(null, body, headers);
        }

      
        if (statusCode === 401) {
            user.clear();
            window.location.href = '/logout';
        }
      

        return fn(error, null, headers);
    });

    return req;
};

/**
 * Performs an XMLHttpRequest.
 *
 * @param {Object|String} options - `request path` or `request parameters`
 * @param {Function} fn - callback function
 * @return { XHR } xhr instance
 * @api public
 */
export default function request(options, fn) {
    if ('string' === typeof options) {
        options = { path: options };
    }

    const settings = Object.assign({}, defaults, options);

    const { authToken, body, formData, headers, isRestAPI, method, query, proxyOrigin } = settings;

    // Envelope mode FALSE as default
    settings.isEnvelopeMode = false;

    settings.url = proxyOrigin + settings.path;

    // create HTTP Request instance
    const req = superagent[method](settings.url);

    // querystring
    if (query) {
        req.query(query);
        settings.isEnvelopeMode = isRestAPI ? query.http_envelope : query._envelope;
    }

    if (body && !formData) {
        req.send(body);
    }

    // POST FormData (for `multipart/form-data`, usually a file upload)
    if (formData) {
        for (let i = 0; i < formData.length; i++) {
    
            const data = formData[i];
            const key = data[0];
            const value = data[1];

            if (isFile(value)) {
                req.attach(key, new File([value.fileContents], value.fileName));
            } else {
                req.field(key, value);
            }
        }
    }

    // headers
    if (headers) {
        req.set(headers);
    }

    if (authToken) {
        req.set('Authorization', `Bearer ${authToken}`);
    }

    if (!req.get('Accept')) {
        // set a default "Accept" header preferring a JSON response
        req.set('Accept', '*/json,*/*');
    }

    sendResponse(req, settings, fn);

    return req.xhr;
}

/**
 * Returns `true` if `v` is a File Form Data, `false` otherwise.
 *
 * @param {Mixed} v - instance to analize
 * @return {Boolean} `true` if `v` is a DOM File instance
 * @private
 */
function isFile(v) {
    return v instanceof Object && 'undefined' !== typeof Blob && v.fileContents instanceof Blob;
}